import {padHex} from 'viem'


export const minterRole = padHex("0x42042069", {dir:"right", size:32})
export const adminRole = padHex("0x69696969", {dir:"right", size:32})
